import { ScannerCore } from './scannerCore'

/**
 * 扫码桥：把 ScannerCore 识别出的完整码交给 ShortcutManager 栈顶 onScan。
 * 业务页面仍通过 useShortcuts 的 onScan 接收，无需改页面。
 */
export class ScannerBridge {
  constructor(manager) {
    this.manager = manager
    /** @type {ScannerCore | null} */
    this.core = null
    this.listening = false
  }

  /**
   * 是否处于扫码 burst（dwell 统计判定中）
   * ShortcutManager 用此信号避让字母/数字/Space 快捷键
   */
  get scanBurstActive() {
    return !!this.core?.scanBurstActive
  }

  /**
   * 付款严格模式：数字从首键吞掉，人手回放给金额
   * @param {boolean} enabled
   * @param {((chars: string) => void) | null} onHumanFlush
   */
  setStrictDigitMode(enabled, onHumanFlush = null) {
    if (!this.core) {
      this.core = new ScannerCore()
    }
    this.core.setStrictDigitMode(enabled, onHumanFlush)
  }

  start() {
    if (this.listening) return
    if (this.manager?.legacyMode) {
      console.log('TIPS scannerBridge skip start: legacyMode=true')
      return
    }
    if (!this.core) {
      this.core = new ScannerCore()
    }
    this.core.start((code) => this._handle(code))
    this.listening = true
    console.log('TIPS scannerBridge started with ScannerCore (dwell+Enter)')
  }

  stop() {
    if (this.core) {
      this.core.stop()
    }
    this.listening = false
  }

  /**
   * 运行时调参（门店/设备）
   * @param {object} patch
   */
  setConfig(patch) {
    this.core?.setConfig(patch)
  }

  getDebugState() {
    return {
      listening: this.listening,
      scanBurstActive: this.scanBurstActive,
      core: this.core?.getDebugState?.() || null,
    }
  }

  _handle(code) {
    if (!code) return
    this.manager?.markScanEnterConsumed()
    const sink = this.manager?.getScanSink()
    if (typeof sink === 'function') {
      sink(code, true)
      return
    }
    console.log('TIPS scannerBridge 无 onScan 接收口，忽略扫码')
  }
}

export default ScannerBridge
